// Find an action option by its value
export function findActionByValue(actionOptions, value) {
  if (!Array.isArray(actionOptions)) return undefined;
  return actionOptions.find((r) => r.value === value);
}

// Find a status option by its value
export function findStatusByValue(statusOptions, value) {
  if (!Array.isArray(statusOptions)) return undefined;
  return statusOptions.find((r) => r.value === value);
}

/**
 * Build filter object from URL search params
 * @param {Object} params - Parsed URL search params
 * @param {Object} options - Available dropdown options
 * @returns {Object} Filter data object for the form
 */
export function buildFilterFromParams(params, options) {
  const { actionOptions, statusOptions } = options;

  const filterData = {};

  // Text fields
  if (params.skuId) filterData.skuId = params.skuId;

  // Single select fields
  if (params.action && actionOptions.length > 0) {
    const matched = findActionByValue(actionOptions, params.action);
    if (matched) filterData.action = matched;
  }
  if (params.status && statusOptions.length > 0) {
    const matched = findStatusByValue(statusOptions, params.status);
    if (matched) filterData.status = matched;
  }

  if (params.pageSize) {
    filterData.pageSize = Number(params.pageSize);
  }

  return filterData;
}

// Clean and normalize the PMX filter object for API requests
export function cleanPMXFilter(filter, pmxDeliveriesRange, pmxDeliveriesSort) {
  const filtered = {};

  // Text fields
  if (filter.skuId) filtered.skuId = filter.skuId;

  // Single select fields - serialize to value
  if (filter.action && typeof filter.action === "object") {
    filtered.action = filter.action.value ?? filter.action.id ?? "";
  } else if (filter.action) {
    filtered.action = filter.action;
  }

  if (filter.status && typeof filter.status === "object") {
    filtered.status = filter.status.value ?? filter.status.id ?? "";
  } else if (filter.status) {
    filtered.status = filter.status;
  }

  // Pagination
  if (pmxDeliveriesRange) filtered.pmxDeliveriesRange = pmxDeliveriesRange;
  if (pmxDeliveriesSort) filtered.pmxDeliveriesSort = pmxDeliveriesSort;
  if (filter.pageSize) filtered.pageSize = filter.pageSize;

  return filtered;
}
